/* @ngInject */
function RepositoryGeneralScreenController ($rootScope, $scope, $attrs, $timeout) {
  $scope.dragAndDrop = false
  $scope.showEmptyMode = false
  $scope.flags = {
    loadingShowMore: false
  }
  $scope.selectedAssets = []
  $scope.selectedFolders = []
  $scope.showAssetsLoading = true
  $scope.mainContent = $attrs.$$element[0].firstChild
  $scope.pricing = {
    organized: {
      access: false,
      pricingPlan: 'Pro'
    }
  }

  const api = {
    _initObserverShowMore,
    _verifyIntersectionButton,
    _getShowMore,
    _validateSectionsAssetsLength,
    _getInitialData
  }

  this.getApi = () => api

  function activate () {
    $timeout(() => {
      api._getInitialData()
      api._initObserverShowMore()
      api._validateSectionsAssetsLength($scope.sections)
    }, 1000)
  }

  activate()

  $scope.handleOpenFolder = (folder) => {
    $scope.openFolder({ folder })
  }

  $scope.handleGoBackFolder = () => {
    $scope.goBackFolder()
  }

  $scope.scrollShowMore = _getShowMore
  $scope.$watch('showHasMoreButton', (showHasMoreButtonNewValue) => {
    if (showHasMoreButtonNewValue) {
      $timeout(() => {
        api._initObserverShowMore()
      }, 500)
    }
  })

  const deregisterSetAssetsSelected = $scope.$on('asset-card.set-assets-selected', (_, assets) => {
    $timeout(() => {
      $scope.selectedAssets.push(...assets)
      $scope.$emit('asset-card.update-selected-assets', $scope.selectedAssets)
    })
  })

  const deregisterLoadAssetsEndEvt = $scope.$on('repository.load-assets-end', () => {
    $timeout(() => {
      $scope.showAssetsLoading = false
      api._validateSectionsAssetsLength($scope.sections)
    })
  })

  const deregisterInitLoadAssetsEvt = $scope.$on('repository.load-assets-start', () => {
    $timeout(() => {
      $scope.showAssetsLoading = true
    })
  })

  const deregisterDragAndDropBlurEvt = $scope.$on('repository.set-drag-and-drop-blur', (event, value) => {
    $scope.dragAndDrop = value
  })

  $scope.$on('$destroy', () => {
    deregisterLoadAssetsEndEvt()
    deregisterDragAndDropBlurEvt()
    deregisterInitLoadAssetsEvt()
    deregisterSetAssetsSelected()
  })

  function _initObserverShowMore () {
    const showMoreButton = $attrs.$$element.find('.button-load-more')

    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.4
    }

    const observer = new IntersectionObserver(api._verifyIntersectionButton, options)

    if (showMoreButton[0]) {
      observer.observe(showMoreButton[0])
    }
  }

  function _verifyIntersectionButton ([entry]) {
    if (entry.isIntersecting && entry.intersectionRatio >= 0.4 && $scope.hasShowMoreButton) {
      $timeout(() => {
        api._getShowMore()
      }, 0, true)
    }
  }

  function _getShowMore () {
    if (!$scope.flags.loadingShowMore) {
      $scope.flags.loadingShowMore = true
      $scope.getAssets().then(() => {
        $scope.flags.loadingShowMore = false
      })
    }
  }

  function _validateSectionsAssetsLength (sections) {
    $scope.showEmptyMode = sections.every(section => section.assets.length === 0)
  }

  function _getInitialData () {
    $rootScope.getCompanyFeaturesAndAddons()
      .then((companyFeatures) => {
        const { features } = companyFeatures
        const hasOrganized = !!features[String('REPOSITORIES.ORGANIZED')]

        $scope.pricing.organized.access = hasOrganized
      })
  }
}

export { RepositoryGeneralScreenController }
